import { type CSSProperties } from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next/pages';
import { getVirtualTourType } from '@pkgs/components/utils/propertyCardUtils';
import { Wrapper } from '@ev-tech/ui-core-components/Wrapper';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { useExposeModal } from '@/providers/ExposeModalProvider';
import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useListing } from '@/hooks/queries/useListing';
import { NO_IMAGES_BACKGROUND } from '@/consts/image';

import styles from './ExposeHeroImage.module.css';

const ActionButtons = dynamic(() => import('./ActionButtons').then((mod) => ({ default: mod.ActionButtons })), {
  ssr: false,
});

export const NoImageFallback = ({ showsButtonGroup }: { showsButtonGroup: boolean }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);
  const { setSelectedMediaTab, openMediaModal } = useExposeModal();
  const {
    data: { listing },
  } = useListing();

  const vTourType = getVirtualTourType(listing?.vtourUrlNormalized, listing?.videoUrlNormalized);

  return (
    <Wrapper className={styles.wrapper} width={{ tabletLandscape: 'l', laptop: 'l' }}>
      <div className={styles.noImagesContainer} style={{ '--no-images-background-image': `url(${NO_IMAGES_BACKGROUND})` } as CSSProperties}>
        <Copy className={styles.copy} text={t('search.expose.imageSlider.label.noImages')} size="m" />
        {Boolean(showsButtonGroup) && (
          <ActionButtons
            totalImages={0}
            hasFloorPlan={Boolean(listing?.floorPlanImages?.length)}
            vTourType={vTourType}
            onBtnClick={(tab) => {
              setSelectedMediaTab(tab);
              openMediaModal();
            }}
          />
        )}
      </div>
    </Wrapper>
  );
};
